module.exports = __webpack_public_path__ + "img/pdf-icon.7684061d.png";